import type { LinkedAccountPlatform } from "@store/linkedAccountSlice";
import { t } from "i18next";
import { twMerge } from "tailwind-merge";
import { getPlatformConfig } from "./platformConfig";

interface PlatformLabelProps {
  platform: LinkedAccountPlatform;
  className?: string;
}

export const PlatformLabel = ({ platform, className }: PlatformLabelProps) => {
  const { label, Icon } = getPlatformConfig(platform);

  return (
    <div className={twMerge("flex shrink-0 items-center gap-[6px]", className)}>
      <div className="flex size-[24px] shrink-0 items-center justify-center overflow-hidden rounded-[7px] bg-black">
        <Icon width={20} height={20} />
      </div>
      <span className="text-[16px] font-medium leading-[22px] text-kds-fg">{t(label)}</span>
    </div>
  );
};
